import React, { useEffect, useState } from 'react';
import { HourglassIcon } from 'lucide-react';
const TOTAL_SECONDS = 22 * 60 + 22;
function useCountdown(initialSeconds: number) {
  const [seconds, setSeconds] = useState(initialSeconds);
  useEffect(() => {
    const id = setInterval(() => setSeconds(s => s > 0 ? s - 1 : 0), 1000);
    return () => clearInterval(id);
  }, []);
  return {
    mm: Math.floor(seconds / 60),
    ss: seconds % 60
  };
}
function Unit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <span className="inline-flex items-baseline gap-1.5" data-id="element-94" data-mp="k30youdzwkkr">
      <span className="font-display text-2xl font-black tabular-nums tracking-wide text-white sm:text-3xl" style={{
      fontFamily: 'Montserrat, sans-serif',
      fontSize: "20px"
    }} data-id="element-95" data-mp="5d39qc88rqui">
        {String(value).padStart(2, '0')}
      </span>
      <span className="text-[10px] font-bold uppercase tracking-widest text-white/70 sm:text-xs" data-id="element-96" data-mp="3shj2ul0tffz3">{label}</span>
    </span>;
}
export function OfferBar() {
  const {
    mm,
    ss
  } = useCountdown(TOTAL_SECONDS);
  return <div role="region" aria-label="Offer countdown" className="fixed inset-x-0 top-0 z-50 border-b-2 border-blush bg-plum text-white shadow-[0_6px_20px_-10px_rgba(11,18,32,0.7)]" data-id="element-97" data-mp="qy0ie7ise9cz">
      <div className="mx-auto flex max-w-5xl items-center justify-between gap-4 px-4 py-3 sm:px-6" style={{
      paddingTop: "5px",
      paddingBottom: "6px",
      width: "374px",
      height: "40px",
      paddingRight: "35px"
    }} data-id="element-98" data-mp="10wzk1654x4qh">
        <p className="flex items-center gap-2.5 text-[13px] font-extrabold uppercase leading-tight tracking-[0.18em] sm:text-base sm:tracking-[0.22em]" data-id="element-99" data-mp="893pa6z4lmwc">
          <HourglassIcon className="h-5 w-5 shrink-0 text-blush" aria-hidden="true" style={{
          width: "17px",
          height: "19px"
        }} data-id="element-100" data-mp="hz5fb4b1hfdw" />
          <span style={{
          fontSize: "8px"
        }} data-id="element-101" data-mp="d6m0y54j2g81">Offer expires in:</span>
        </p>

        <p className="flex shrink-0 items-baseline gap-1.5 sm:gap-2.5" data-id="element-102" data-mp="3lm5pwry61cha">
          <Unit value={mm} label="Min" data-id="element-103" data-mp="3gpf9g3ig8evc" />
          <span className="text-xl font-black text-blush" data-id="element-104" data-mp="3godp18fjmg0y">:</span>
          <Unit value={ss} label="Sec" data-id="element-105" data-mp="1kkg07ifd6mlg" />
        </p>
      </div>
    </div>;
}